// src/pages/admin/Settings.tsx
// src/pages/admin/Setting.tsx
import SettingManager from "../../components/admin/Setting";

export default function AdminSettingPage() {
  return (
    <div className="p-6">
      <SettingManager />
    </div>
  );
}
